import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { useFinancialSummary } from "@babackapp/return-widget-components/hooks/use-financial-summary";
import { usePublicOrder } from "@babackapp/return-widget-components/queries/use-public-order";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { ArrowLeft, ShoppingBagIcon } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postToParent } from "../lib/shop-now-embed";
import { useWidgetParams } from "../hooks/use-widget-params";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { useSetRebuyItems } from "@babackapp/return-widget-components/hooks/use-set-rebuy-items";

export function ShopNowPage() {
  const navigate = useNavigate();
  const { orderId } = useWidgetParams();
  const { data: order } = usePublicOrder(orderId);
  const financialSummary = useFinancialSummary(orderId, order ?? null);

  useEffect(() => {
    postToParent({
      type: "SHOP_NOW_PRELOAD",
      orderId,
      exchangeCreditAmount: financialSummary.exchangeTotal,
      currency: financialSummary.currency,
      taxMultiplier: financialSummary.taxMultiplier,
    });
  }, [orderId, financialSummary.exchangeTotal, financialSummary.currency, financialSummary.taxMultiplier]);

  const setRebuyItems = useSetRebuyItems(orderId);

  const handleGoShopping = () => {
    setRebuyItems([]);
    postToParent({ type: "SHOP_NOW_START" });
  };
  const t = useCustomText();

  const creditLabel =
    financialSummary.exchangeTotal > 0
      ? formatPrice(financialSummary.exchangeTotal, financialSummary.currency)
      : null;

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>{t("shopNow.titleShopping")}</HeaderTitle>
        <HeaderDescription>
          {creditLabel
            ? t("shopNow.descriptionWithCredit", { amount: creditLabel })
            : t("shopNow.descriptionNoCredit")}
        </HeaderDescription>
      </Header>

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer layoutId="line-item-back-button" disableVariants={{ exit: true }}>
          <Button variant="secondary" type="button" onClick={() => navigate(-1)}>
            <ArrowLeft />
            {t("common.back")}
          </Button>
        </AnimatedButtonContainer>
        <AnimatedButtonContainer layoutId="shop-now-go" variants={{}}>
          <Button onClick={handleGoShopping}>
            <ShoppingBagIcon />
            {t("shopNow.ctaShopping")}
          </Button>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
